import { useLayoutEffect, useRef } from 'react';

import { usePrevious } from 'hooks';
import { getStepKeys } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepConstants';

// STEPS is declared in flow order, so a lower index means the user moved back
const STEP_SEQUENCE = getStepKeys();

// Returns 'forward' | 'back' once the step has changed, null on first open so it doesn't animate
export const useStepTransition = (currentStep, contentRef) => {
  const previousStep = usePrevious(currentStep);
  const hasStepChanged = previousStep !== currentStep;

  const directionRef = useRef(null);
  if (hasStepChanged) {
    const isBack =
      STEP_SEQUENCE.indexOf(currentStep) < STEP_SEQUENCE.indexOf(previousStep);
    directionRef.current = isBack ? 'back' : 'forward';
  }

  useLayoutEffect(() => {
    if (hasStepChanged) contentRef.current?.scrollTo({ top: 0 });
  }, [contentRef, currentStep, hasStepChanged]);

  return directionRef.current;
};

export default useStepTransition;
